export default __webpack_public_path__ + "static/media/down-arrow.27e76c53.svg";